<template>
  <g>
    <path
      d="M12.332 1.9974H11.6654V0.664062H10.332V1.9974H3.66536V0.664062H2.33203V1.9974H1.66536C0.932031 1.9974 0.332031 2.5974 0.332031 3.33073V13.9974C0.332031 14.7307 0.932031 15.3307 1.66536 15.3307H12.332C13.0654 15.3307 13.6654 14.7307 13.6654 13.9974V3.33073C13.6654 2.5974 13.0654 1.9974 12.332 1.9974ZM12.332 13.9974H1.66536V5.33073H12.332V13.9974Z"
    />
  </g>
</template>
